import * as React from 'react';
import { render } from 'react-dom';
import AdSenseObjectPage from './ad-sense-object-page';

export function renderAdSenseObjectPage(id: string, callback?: () => void) {
    if (document) {
        const container = document.getElementById(id + '-container');

        if (container) {
            const query = container.getAttribute('data-query');
            const channel = container.getAttribute('data-channel');
            const width = container.getBoundingClientRect().width;
            render(
                <AdSenseObjectPage
                    id={id}
                    channel={channel}
                    query={query}
                    width={width}
                />,
                container,
                callback,
            );
        }
    }
}
